import { NSARouterMakerResult } from "namirasoft-account-react";
import { FiscalYearRow } from "namirasoft-erp";
import { Component } from "react";
import { ErpRouterProps } from "../ErpRouterProps";
import { FiscalYearBranchesView, FiscalYearBranchRow } from "./FiscalYearBranchesView";

interface FiscalYearBranchesViewLoaderProps extends NSARouterMakerResult, ErpRouterProps
{
    fiscal_year_id: string;
}

interface FiscalYearBranchesViewLoaderState
{
    rows: FiscalYearBranchRow[] | null;
}

export class FiscalYearBranchesViewLoader extends Component<FiscalYearBranchesViewLoaderProps, FiscalYearBranchesViewLoaderState>
{
    override state: FiscalYearBranchesViewLoaderState = { rows: null };

    override componentDidMount(): void
    {
        this.load();
    }

    override componentDidUpdate(prev: FiscalYearBranchesViewLoaderProps): void
    {
        if (prev.fiscal_year_id !== this.props.fiscal_year_id)
            this.load();
    }

    private async load(): Promise<void>
    {
        let { fiscal_year_id: id } = this.props;
        if (!id) { this.setState({ rows: null }); return; }
        try
        {
            let row = await this.props.servers.erp.fiscal_year.Get(id);
            let branches = ((row as unknown as FiscalYearRow & { branches?: FiscalYearBranchRow[] }).branches) ?? [];
            this.setState({ rows: branches });
        }
        catch (e)
        {
            console.error(e);
        }
    }

    override render()
    {
        let { rows } = this.state;
        if (!rows)
            return null;
        return (
            <FiscalYearBranchesView
                {...this.props}
                fiscal_year_id={this.props.fiscal_year_id}
                rows={rows}
            />
        );
    }
}